import { useStore } from '../zustand';
import { fetchHRX, fetchPayload, fetchStoreSettings, fetchReviews } from "./fetchData";
import { sendAnalyticsData } from "./handleAnalytics";
import { setSessionID, default_levar_text_settings, _billboard_status_controller, _variant_switch_status_controller, _billboard_variant_switch_status_controller, extractVariantId, setBooleanValue, buildOptions, _setCustomBannerURL } from "./helpers";
import WebFont from 'webfontloader';
const { REACT_APP_VIEWER_MODE } = process.env;

export const handleShadeStart = async (params) => {
    // const unsub1 = useStore.subscribe(console.log) // turn on to see zustand in console

    // BLOCK IF No Params || IF Params but no variant
    if(!Object.getOwnPropertyNames(params).length > 0 || !params.variant) {
        useStore.setState({ appStatus: "SHADE_BLOCKED" });
        return;
    };

    const { variant_id, variant_type } = extractVariantId(params.variant);
    
    const payload = await fetchPayload(variant_id, variant_type); // API
    console.log('payload>>>', payload);

    // Block if no vList (ie no variants found) || response no variants || fetch error
    if(!payload?.vList || payload.response === 'No variants found!' || !payload) {
        useStore.setState({ appStatus: "SHADE_BLOCKED" });
        return;
    }
    // TODO: only run if product has options variant swtich on
    // if(payload.options.length) {}
    const model_options_final = buildOptions(payload.vList, params)
    
    const { status, stage } = payload.vList[variant_id];
    const assetStatus = checkStatus(status, stage);
    // console.log('here', payload.vList[variant_id])
    if(!assetStatus) {
        useStore.setState({ appStatus: "SHADE_BLOCKED" });
        return;
    }

    // **** Dynamic Settings **** //
    const store_settings = await fetchStoreSettings(variant_type, payload.store_id); // API
    console.log('store_settings', store_settings)
    let dynamic_text_settings = store_settings.result.dynamic_text_settings;
    // console.log('store_settings', store_settings)
    if(dynamic_text_settings?.custom_text_status) {
        if(dynamic_text_settings?.default_text_font) {
            WebFont.load({
                google: {
                    api: 'https://fonts.googleapis.com/css2',
                    families: [`${dynamic_text_settings.default_text_font}:wght@100;300;400;600;900&display=swap`]
                }
            });
        }
    }
    
    // **** Yotpo Reviews **** //
    //const yotpo_id = '5UtSoU5xcRhi0pfxRAOh4t54KsAXtnEAt68iEQCF'; // Update this with new api after testing
    const yotpo_id = store_settings.result.yotpo_id; // Update this with new api after testing
    //const product_id = '773663195225'; // payload.vList[variant_id].product_id
    const product_id = payload.vList[variant_id].product_id;
    let reviews;
    var tabs_enabled = true; // Manual override, normally set to false

    if (yotpo_id && product_id) {
        reviews = await fetchReviews(product_id, yotpo_id); // API
        tabs_enabled = true; 
    } else {
        reviews = {
            "status": {
                "code": 200,
                "message": "OK"
            },
            "response": {
                "bottomline": {
                    "total_review": 166,
                    "average_score": 4.91429,
                    "total_organic_reviews": 0,
                    "organic_average_score": 0,
                    "star_distribution": {
                        "1": 0,
                        "2": 1,
                        "3": 0,
                        "4": 3,
                        "5": 66
                    },
                    "custom_fields_bottomline": null
                },
                "reviews": [
                    {
                        "id": 337511709,
                        "score": 5,
                        "votes_up": 0,
                        "votes_down": 0,
                        "content": "I bought this for our home and it was the perfect fit. Such and easy company to work with and their customer service was great.",
                        "title": "Loved this purchase",
                        "created_at": "2022-02-13T15:52:02.000Z",
                        "deleted": false,
                        "verified_buyer": true,
                        "source_review_id": null,
                        "sentiment": 0.985506,
                        "custom_fields": null,
                        "product_id": 159521849,
                        "user": {
                            "user_id": 65824164,
                            "social_image": null,
                            "user_type": "User",
                            "is_social_connected": 0,
                            "display_name": "Michelle"
                        }
                    },
                    {
                        "id": 315691457,
                        "score": 5,
                        "votes_up": 0,
                        "votes_down": 0,
                        "content": "This was perfect for my home. Fit in well with my colors and style! Will definitely buy from them again.",
                        "title": "Was perfect for my home",
                        "created_at": "2021-11-29T15:10:29.000Z",
                        "deleted": false,
                        "verified_buyer": true,
                        "source_review_id": null,
                        "sentiment": 0.978972,
                        "custom_fields": null,
                        "product_id": 159521849,
                        "user": {
                            "user_id": 1377738,
                            "social_image": null,
                            "user_type": "User",
                            "is_social_connected": 0,
                            "display_name": "Dan"
                        }
                    },
                    {
                        "id": 308480256,
                        "score": 5,
                        "votes_up": 0,
                        "votes_down": 0,
                        "content": "The material and components are super high quality. The service was great and their customer service answered all of my questions.",
                        "title": "Super High Quality",
                        "created_at": "2021-11-05T22:33:43.000Z",
                        "deleted": false,
                        "verified_buyer": true,
                        "source_review_id": null,
                        "sentiment": 0.985484,
                        "custom_fields": null,
                        "product_id": 159521849,
                        "user": {
                            "user_id": 61234399,
                            "social_image": null,
                            "user_type": "User",
                            "is_social_connected": 0,
                            "display_name": "Ben"
                        }
                    }
                ]
            }
        }
        if (payload.vList['32229299126306']) {
            reviews = {
                "status": {
                    "code": 200,
                    "message": "OK"
                },
                "response": {
                    "bottomline": {
                        "total_review": 166,
                        "average_score": 4.91429,
                        "total_organic_reviews": 0,
                        "organic_average_score": 0,
                        "star_distribution": {
                            "1": 0,
                            "2": 1,
                            "3": 0,
                            "4": 3,
                            "5": 66
                        },
                        "custom_fields_bottomline": null
                    },
                    "reviews": [
                        {
                            "id": 337511709,
                            "score": 5,
                            "votes_up": 0,
                            "votes_down": 0,
                            "content": "I just bought these boots and I was originally looking for Irish setters but these were so much more comfortable and affordable.",
                            "title": "New boots",
                            "created_at": "2022-02-13T15:52:02.000Z",
                            "deleted": false,
                            "verified_buyer": true,
                            "source_review_id": null,
                            "sentiment": 0.985506,
                            "custom_fields": null,
                            "product_id": 159521849,
                            "user": {
                                "user_id": 65824164,
                                "social_image": null,
                                "user_type": "User",
                                "is_social_connected": 0,
                                "display_name": "Michelle"
                            }
                        },
                        {
                            "id": 315691457,
                            "score": 5,
                            "votes_up": 0,
                            "votes_down": 0,
                            "content": "This is my 2nd pair of boots they were on sale during cyber Monday week. Bought them for a backup pair.and new inserts for the 1st pair…I’ve owned and used some of the best boots in construction from redwing. The keen Cincinnati is the best boot on the planet….don’t change a thing………thanks from the bottom of my feet.",
                            "title": "Bitching boots",
                            "created_at": "2021-11-29T15:10:29.000Z",
                            "deleted": false,
                            "verified_buyer": true,
                            "source_review_id": null,
                            "sentiment": 0.978972,
                            "custom_fields": null,
                            "product_id": 159521849,
                            "user": {
                                "user_id": 1377738,
                                "social_image": null,
                                "user_type": "User",
                                "is_social_connected": 0,
                                "display_name": "Dan"
                            }
                        },
                        {
                            "id": 308480256,
                            "score": 5,
                            "votes_up": 0,
                            "votes_down": 0,
                            "content": "After much research into what wedge boot would be the best for my 14 hour days on my feet w/ plantar fasciitis and other foot pain, I went with these Cincinnati’s. As soon as I got them I was impressed. Solid construction, nice thick leather with supple padding, strong laces/lace locks thick soles etc this was all before I put them on! I got a half size smaller and was a little nervous about sizing, but they fit perfectly (for me) roomy toe box, super strong leather and stitching I worked my first shift in them and didn’t even think about my feet all day. No pains, limited sweating and sharp looking. If you are in the market, try these out! I would recommend over and over to anyone! Would buy again! Make sure to treat them with whatever you use for conditioning leather and enjoy.",
                            "title": "Hard to impress...",
                            "created_at": "2021-11-05T22:33:43.000Z",
                            "deleted": false,
                            "verified_buyer": true,
                            "source_review_id": null,
                            "sentiment": 0.985484,
                            "custom_fields": null,
                            "product_id": 159521849,
                            "user": {
                                "user_id": 61234399,
                                "social_image": null,
                                "user_type": "User",
                                "is_social_connected": 0,
                                "display_name": "Ben"
                            }
                        }
                    ]
                }
            }
        }
        if (payload.vList['42450654691515']) {
            reviews = {
                "status": {
                    "code": 200,
                    "message": "OK"
                },
                "response": {
                    "bottomline": {
                        "total_review": 166,
                        "average_score": 4.91429,
                        "total_organic_reviews": 0,
                        "organic_average_score": 0,
                        "star_distribution": {
                            "1": 0,
                            "2": 1,
                            "3": 0,
                            "4": 3,
                            "5": 66
                        },
                        "custom_fields_bottomline": null
                    },
                    "reviews": [
                        {
                            "id": 337511709,
                            "score": 5,
                            "votes_up": 0,
                            "votes_down": 0,
                            "content": "This smoker is super easy to use and convenient, I was able to impress all my friends at our beach party this summer.",
                            "title": "Best smoker around",
                            "created_at": "2022-02-13T15:52:02.000Z",
                            "deleted": false,
                            "verified_buyer": true,
                            "source_review_id": null,
                            "sentiment": 0.985506,
                            "custom_fields": null,
                            "product_id": 159521849,
                            "user": {
                                "user_id": 65824164,
                                "social_image": null,
                                "user_type": "User",
                                "is_social_connected": 0,
                                "display_name": "Michelle"
                            }
                        },
                        {
                            "id": 315691457,
                            "score": 5,
                            "votes_up": 0,
                            "votes_down": 0,
                            "content": "So portable and easy to clean. We made awesome ribs for the whole family at the park.",
                            "title": "No better way to cook!",
                            "created_at": "2021-11-29T15:10:29.000Z",
                            "deleted": false,
                            "verified_buyer": true,
                            "source_review_id": null,
                            "sentiment": 0.978972,
                            "custom_fields": null,
                            "product_id": 159521849,
                            "user": {
                                "user_id": 1377738,
                                "social_image": null,
                                "user_type": "User",
                                "is_social_connected": 0,
                                "display_name": "Dan"
                            }
                        },
                        {
                            "id": 308480256,
                            "score": 5,
                            "votes_up": 0,
                            "votes_down": 0,
                            "content": "I use my smoker all the time for chicken, pork and beef. I can’t imagine using anything else.",
                            "title": "Every day is smoked meet day!",
                            "created_at": "2021-11-05T22:33:43.000Z",
                            "deleted": false,
                            "verified_buyer": true,
                            "source_review_id": null,
                            "sentiment": 0.985484,
                            "custom_fields": null,
                            "product_id": 159521849,
                            "user": {
                                "user_id": 61234399,
                                "social_image": null,
                                "user_type": "User",
                                "is_social_connected": 0,
                                "display_name": "Ben"
                            }
                        }
                    ]
                }
            }
        }   
    }
    console.log('reviews', reviews);

    // Video description and spec sheet
    var video_desc = '';
    var spec_sheet = '';

    if (variant_id === '42507319574690') {
        video_desc = 'Ana embodies modern elegance. Faceted heavy cut crystal shades gleam against a Black Oxide or Heritage Brass finish. Like a piece of statement-making jewelry, Ana is the signature finishing touch in any setting.';
        spec_sheet = 'https://www.hinkley.com/product_spec_print/download/advancedpdf/product_id/56915/';
    }

    if (variant_id === '42511609626786') {
        video_desc = 'Subtle curves, tall legs, and thin arms are design features that make Harriet shine. Grey-toned wicker complements your choice of silver or mist fabrics for a timeless, neutral color palette.';
        spec_sheet = 'https://cdn.shopify.com/s/files/1/2637/1486/files/Harriet-compressed.pdf';
    }

    if (variant_id === '32229299126306') {
        video_desc = 'This heavy-duty wedge introduces lightweight comfort into a classic style. Carbon-fiber toes and an air-infused Luftcell midsole offer unbeatable comfort.';
        spec_sheet = '';
    }

    if (variant_id === '42450654691515') {
        video_desc = 'Learn about the versatility of cooking on your Ozpig and how to get the right heat for different cooking styles!';
        spec_sheet = 'https://cdn.shopify.com/s/files/1/0570/2270/9968/files/Ozpig_Oven_Smoker_Handbook_February_2022_Compressed.pdf?v=1645752234';
    }


    let store_new_settings = { 
        ...store_settings.result,
        dynamic_text_settings: dynamic_text_settings?.custom_text_status ? dynamic_text_settings : { ...default_levar_text_settings },
        custom_banner_url: store_settings?.result?.ar_experience?.ar_cta_status ? _setCustomBannerURL(variant_id, variant_type) : null,
        tabs_enabled: tabs_enabled
    }

    // console.log('store_new_settings', store_new_settings)

    // **** Heuristics **** //
    const hrxData = await fetchHRX();
    console.log('hrxData', hrxData)
    // **** Billboards **** //
    const { billboard_status, billboard_list, animation_solo, options } = payload.vList[variant_id];
    // currently not being used
    console.log('billboard_status not used?::', billboard_status)
    const billboards_enabled = _billboard_status_controller(billboard_list, params.viewer_type);
    // console.log('billboards_enabled', billboards_enabled)
    const variant_switch_enabled = _variant_switch_status_controller(options, params.viewer_type);
    const billboard_variant_switch_enabled = _billboard_variant_switch_status_controller(billboard_list, options, params.viewer_type);

    // Store Information and show model
    useStore.setState((state) => ({
        appStatus: "SHADE_READY",
        hrx: { ...hrxData },
        variants_payload: { ...payload },
        variant_id: variant_id,
        store_settings: { ...store_new_settings },
        reviews: reviews ?? null,
        video_desc: video_desc ?? null,
        spec_sheet: spec_sheet ?? null,
        settings: { // todo: move all to param settings
            origin: params.origin ?? null,
            product_session_id: params.product_session_id ?? setSessionID(),
            variant_session_id: params.variant_session_id ?? setSessionID(),
            viewer_session_id: params.viewer_session_id ?? setSessionID(),
            levar_session_token: params.levar_session_token ?? setSessionID(),
            view_in_space_off: setBooleanValue(params.view_in_space_off),
            viewer_type: params.viewer_type ?? null,
            variant_switch_ui: Boolean(params.variant_switch_ui) ?? null,
            store_id: payload.store_id ?? "",
            variant_type: variant_type,
            addToCartBtn: params.add_to_cart === 'on' ? true : false,
            ar_activation: params.ar_activation ? Boolean(params.ar_activation) : null,
        },
        model_options: {
            ...model_options_final
        },
        scene_controls: {
            ...state.scene_controls,
            active_board: billboards_enabled ? 0 : null,
            billboards_enabled: billboards_enabled,
            variant_switch_enabled: variant_switch_enabled,
            billboard_variant_switch_enabled: billboard_variant_switch_enabled,
            controls_ui: !animation_solo
        },
    }));
    // console.log('state', useStore.getState())
    // ANALYTICS POST for QR camera code send on (Shopify || BigC Desktop => External Mobile)
    if(params.origin === 'external' && params.variant_session_id && params.product_session_id) {
        await sendAnalyticsData({ event_type: 'qr_button_launch' });
    }

    if(params.viewer_type === 'levar_debut' || params.viewer_type === 'billboard_display') return;

    // setDisplayModal();
    // unsub1();
}

// CHECK asset status and stage
const checkStatus = (status, stage) => {
    switch (stage) {
        case 3:
            if(REACT_APP_VIEWER_MODE === 'development') {
                return true
            } else { return false }
        case 4:
            return true
        case 5:
            return status
        default:
            return false
    };
};

// SET modal displays
// const setDisplayModal = () => {
//     const { intent } = useStore.getState().hrx;

//     switch(intent) {
//         case 'willSV': // Andriod || IOS directions for AR (Will QL || SV)
//             useStore.setState({ modalView: { display: 'MobilePrompt', status: true }});
//             break;
//         default:
//             break;
//     };
// };

// TODO: For Desktop display modal
// case 'willDQL': case 'willDSV': // Desktop Directions for viewer (Will Download QL || SV)
// useStore.setState({ modalView: { display: 'DesktopPrompt', status: true }});
// break;

// WebView and Unsupported browser directions for ios || andriod (Can QL || SV)
// case 'canQL': case 'canSV':
// useStore.setState({ modalView: { display: 'RedirectPrompt', status: true }});
// break;

